import { BookOpen, Users, Heart, Music, HardHat } from 'lucide-react'
import Hero from '../components/Hero'
import ProgramCard from '../components/ProgramCard'
import SEO from '../components/SEO'

export default function Programs() {
  const programs = [
    {
      title: 'Theology',
      description: 'Deepen your understanding of Scripture, Christian doctrine, and ministry practice. Our comprehensive theology program prepares you for effective ministry and spiritual leadership in churches and communities.',
      image: '/assets/images/pexels-pixabay-372326.jpg',
      link: '/programs/theology',
      icon: BookOpen
    },
    {
      title: 'Leadership',
      description: 'Develop transformational leadership skills rooted in Christian values and ethical principles. Learn to lead with integrity, vision, and compassion in various organizational contexts.',
      image: '/assets/images/pexels-kampus-7551674.jpg',
      link: '/programs/leadership',
      icon: Users
    },
    {
      title: 'Nursing Diploma',
      description: 'Combine compassionate care with clinical excellence in our accredited nursing diploma program. Train to serve communities with professional healthcare grounded in Christian values of service.',
      image: '/assets/images/pexels-rdne-6129194.jpg',
      link: '/programs/nursing',
      icon: Heart
    },
    {
      title: 'Music Ministry',
      description: 'Develop spiritually mature and musically equipped ministers who lead worship with excellence. Learn to use your gifts to serve God and the church with sensitivity to the Holy Spirit.',
      image: '/assets/images/music_image.jpg',
      link: '/programs/music-ministry',
      icon: Music
    },
    {
      title: 'Construction Management',
      description: 'Equip yourself with practical skills and leadership ability to plan, coordinate, and supervise construction projects. Master resource management, timelines, budgets, and professional standards in the construction industry.',
      image: '/assets/images/pexels-pixabay-268362.jpg',
      link: '/programs/construction-management',
      icon: HardHat
    }
  ]

  return (
    <>
      <SEO 
        title="Programs - Rudovia Life College"
        description="Explore our programs in Theology, Leadership, Nursing Diploma, Music Ministry, and Construction Management. Quality Christian education preparing you for professional excellence and meaningful service."
        keywords="theology program Africa, leadership courses, nursing diploma Zimbabwe, music ministry training, construction management, Christian education programs"
      />
      <div className="pt-20">
        <Hero
          title="Our Programs"
          subtitle="Choose from our diverse range of programs designed to equip you for excellence in your calling"
          image="/assets/images/avery-evans-uvcUq8cGncQ-unsplash.jpg"
          height="h-[400px]"
        />

        <section className="section-padding bg-white">
          <div className="container-custom">
            <div className="text-center mb-12">
              <h2 className="heading-2 mb-4">Transform Your Future</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                At Rudovia Life College, we offer programs that combine academic excellence with spiritual formation, preparing you for both professional success and meaningful service to others.
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {programs.map((program) => (
                <ProgramCard key={program.title} {...program} />
              ))}
            </div>
          </div>
        </section>

        <section className="section-padding bg-gray-50">
          <div className="container-custom">
            <div className="text-center mb-12">
              <h2 className="heading-2 mb-4">What Makes Our Programs Unique?</h2>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-lg p-8">
                <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center mb-4">
                  <BookOpen className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-primary mb-3">Faith-Integrated Learning</h3>
                <p className="text-gray-600">
                  Every program integrates Christian principles with professional training, developing both your skills and character.
                </p>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-8">
                <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center mb-4">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-primary mb-3">Expert Faculty</h3>
                <p className="text-gray-600">
                  Learn from experienced professionals and scholars who are passionate about mentoring the next generation of leaders.
                </p>
              </div>
              <div className="bg-white rounded-xl shadow-lg p-8">
                <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center mb-4">
                  <Heart className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-primary mb-3">Practical Experience</h3>
                <p className="text-gray-600">
                  Gain hands-on experience through internships, practicums, and real-world projects that prepare you for your career.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section-padding bg-gradient-to-r from-primary to-blue-900 text-white">
          <div className="container-custom text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Begin Your Journey?</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              Take the first step toward a rewarding career and a life of meaningful service. Apply to Rudovia Life College today.
            </p>
            <a href="/admissions" className="btn-secondary">
              Apply Now
            </a>
          </div>
        </section>
      </div>
    </>
  )
}
